import React, { Component } from 'react'
// import ScrollAnimation from 'react-animate-on-scroll'


// import { ProfileInfo } from './'

class AboutPage extends Component {
  render () {
    return (
      <div className="About">

        <div className="screen-bg">
        <div className="about-masthead">
          <div className="container">
            <div className="row center-xs">
              <div className="col-xs-10">
                <div className="box">
                  <h1>Quite simply afrodesiamedia works as a small web agency
                    centered on building web applications. We can help you
                    thru all the phases of the design process.
                  </h1>
                </div>
              </div>
            </div>

          </div>
          </div>
        </div>

        <div className="container">
          <div className="row between-xs">
            <div className="col-xs-4">
              <article className="box">
                <h2>Sketching / Wireframing</h2>
                <ul>
                  <li>Where we start generating rough ideas and elementsto formulate the basic building blocks.</li>
                </ul>
              </article>
            </div>
            <div className="col-xs-4">
              <article className="box">
                <h2>Hi-Fi Mockups</h2>
                <ul>
                  <li>
                    This is the phase where we start fleshing out the building blocks to a more concrete and solid design concept and developing a color pallete , typography and more.
                  </li>
                </ul>
              </article>
            </div>

            <div className="col-xs-4">
              <article className="box">
                <h2>Development</h2>
                <ul>
                  <li>
                    
                    <p>
                    HTML, CSS plus a sprinkle of Javascript are used to and real form to the Hi-Fi mockups
                    </p>
                    <i className="fab fa-react"></i>
                    <i className="fab fa-html5"></i>
                    <i className="fab fa-css3-alt"></i>
                    <i className="fab fa-node-js"></i>
                    

                    
                  </li>
                </ul>
              </article>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default AboutPage



// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/About/components/AboutPage.js